module.exports = __webpack_public_path__ + "503257b3c1d7a1a2813dd38b350729de.png";